angular.module('leanlaw').controller('SummaryUsersController', ['$scope', '$rootScope', '$q', '$window', '$filter', "$timeout", '$location', '$stateParams', '$state', "alerts", "userService", "reportsService", "leanLawApi", "exportJson", "singleRequest", function ($scope, $rootScope, $q, $window, $filter, $timeout, $location, $stateParams, $state, alerts, userService, reportsService, leanLawApi, exportJson, singleRequest) {
  $scope.data = {};

  // $scope.filter is owned by sidebar

  //
  function load() {
    if ($scope.activeTab != "users") return;
    var query = queryFromFilter();
    if (!query) return;
    query.billed = 'any';
    query.billedState = undefined;
    query.primary = 'accounts';
    $scope.loading = true;
    singleRequest.apiCall("tabdetail").getReport(query).then(function (data) {
      if (!data) return;
      $scope.data = data;
      $scope.loading = false;
    }).catch(function (err) {
      alerts.error(err);
      console.log(err);
      $scope.loading = false;
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    var query = reportsService.queryFromFilter($scope.filter);
    query.scope = null;
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.export = function () {
    const exp = $scope.data.filteredUsers.map(u => ({
      "Name": u.user.name,
      "Hours non-billable": $filter("hoursDecimal")(u.data.hours.nonBillable),
      "Hours billable": $filter("hoursDecimal")(u.data.hours.billable),
      "Hours total": $filter("hoursDecimal")(u.data.hours.total),
      "Hours amount": $filter("amount")(u.data.amounts.hours)
    }));
    exportJson.downloadCsv(exp);
  };
  $scope.$on('commonFilterService-statechanged', function (event, payload) {
    $timeout(load);
  });
  $scope.$on("report-sidebar-filterchange", function (event, payload) {
    $timeout(load);
  });

  // Suffix is the active tab name for this view
  $scope.$on("summary-export-users", payload => {
    $scope.export();
  });
  $scope.$watch("cm", newValue => {
    $timeout(load);
  });
  $scope.$watch("activeTab", newValue => {
    $timeout(load);
  });
}]);